// Reason: While this prohibition remains valid for most cases,
//         ConcurrentPresentation is using it internally so we need the type to
//         match.
/* eslint-disable @typescript-eslint/ban-types */

import { ConcurrentPresentation, usePresentation } from '@visiba/presentation';
import { Fragment, ReactNode, Suspense } from 'react';

interface ClassWithPresentation<T extends object> {
	presentation: ConcurrentPresentation<T>;
}

interface Props<T extends object> {
	fallback: JSX.Element;
	controller: ClassWithPresentation<T>;
	children: ((props: T) => ReactNode) | ReactNode;
}

function PresentationReader<T extends object>(props: Props<T>): JSX.Element {
	const data = usePresentation(props.controller.presentation);

	return <Fragment>{typeof props.children === 'function' ? props.children(data) : props.children}</Fragment>;
}

export function SuspendedPresentation<T extends object>(props: Props<T>): JSX.Element {
	return (
		<Suspense fallback={props.fallback}>
			<PresentationReader {...props} />
		</Suspense>
	);
}
